import * as AT from '../action/actionTypes';


const initialState = {
    secound: 0,
    open: false,
    openModal: false,
    counterTime: 0,
    userInfo: '',
    planInfo: null,
    email_exist: null
}


const generalReducer = (state = initialState, action) => {

    switch (action.type) {
        case AT.SET_SECOUND:
            return {
                ...state,
                secound: action.sec
            }
        case AT.SET_OPEN_DRAWER:
            return {
                ...state,
                open: action.open
            }
        case AT.OPEN_COUNTER_MODAL:
            return {
                ...state,
                openModal: action.openModal,
                counterTime: action.counterTime
            }
        case AT.SET_USER_INFO:
            return {
                ...state,
                userInfo: action.userInfo
            }
        case AT.SET_IS_UPLOADER_EMAIL:
            return {
                ...state,
                email_exist: action.bol
            }
        default:
            return {
                ...state
            }
    }
}

export default generalReducer